import React from 'react';
import Page from "../common/Page";
import { Button, Card, Content, Dropdown } from "react-bulma-components";
import Pluralize from 'react-pluralize';
import {
    UilCheckCircle,
    UilEllipsisH,
    UilExclamationTriangle,
    UilPaintTool,
    UilPlusCircle,
    UilTrash
} from '@iconscout/react-unicons';
import { Link } from "react-router-dom";
import useSWR from 'swr';
import { format, formatDistanceToNow } from "date-fns";
import { Icon, IconText } from "../common/Icon";
import Loading from "../common/Loading";
import { fetcher } from "../utils/fetch";

export default function ProjectsPage() {
    const { data, error } = useSWR('/api/projects', fetcher);

    const projects = (data || []).map((project) => {
        const startedAt = new Date(project.started_at);
        const completedAt = new Date(project.completed_at);

        let overdueAlert;
        if (project.is_overdue) {
            overdueAlert = (
                <div className="px-5 py-2 has-background-warning">
                    <IconText icon={ UilExclamationTriangle }>
                        This project started <time
                        dateTime={ startedAt.toISOString() }>{ formatDistanceToNow(startedAt) }</time> ago and isn't
                        complete yet! Maybe it's time to check-in?
                    </IconText>
                </div>
            );
        }

        return (
            <Card key={ project.id } mb={ 5 }>
                { overdueAlert }

                <Card.Content pt={ 4 }>
                    <div className="mb-4 is-flex is-align-items-center">
                        <div className="is-flex-grow-1">
                            <p className="title is-4">
                                <Link to={ `/projects/${ project.id }` }>
                                    { project.name }
                                </Link>
                            </p>
                        </div>


                        {/* TODO: Check aria stuff */ }
                        <Dropdown color="ghost" hoverable right label={
                            <Icon className="is-small" icon={ UilEllipsisH }/>
                        }>
                            {
                                project.completed_at === null
                                    ? <div/>
                                    : (
                                        <Dropdown.Item renderAs="a" value="mark-as-complete">
                                            <IconText icon={ UilCheckCircle }>
                                                Mark as complete
                                            </IconText>
                                        </Dropdown.Item>
                                    )
                            }

                            {
                                // TODO: This logic is a bit weird
                                project.completed_at || project.started_at
                                    ? <Dropdown.Divider/>
                                    : <div/>
                            }

                            <Dropdown.Item renderAs="a" value="delete">
                                <IconText className="has-text-danger" icon={ UilTrash }>
                                    Delete
                                </IconText>
                            </Dropdown.Item>
                        </Dropdown>
                    </div>

                    <Content>
                        <p>{ project.description }</p>
                    </Content>
                </Card.Content>

                <Card.Footer>
                    <Card.Footer.Item>
                        <span className="has-tooltip-arrow"
                              data-tooltip={ project.rooms.map(r => r.name).join("\n") }>
                            <Pluralize singular="room" count={ project.rooms.length }/>
                        </span>
                    </Card.Footer.Item>

                    <Card.Footer.Item>
                        {
                            project.started_at
                                ? <span>Started <time
                                    dateTime={ startedAt.toISOString() }>{ format(startedAt, 'dd/MM/yyyy') }</time></span>
                                : <span className="has-text-danger">Not started yet</span>
                        }
                    </Card.Footer.Item>

                    <Card.Footer.Item>
                        {
                            project.completed_at
                                ? <span>Completed <time
                                    dateTime={ completedAt.toISOString() }>{ format(completedAt, 'dd/MM/yyyy') }</time></span>
                                : <span>Not completed yet</span>
                        }
                    </Card.Footer.Item>
                </Card.Footer>
            </Card>
        );
    });

    return (
        <Loading loading={ !data || error }>
            <Page icon={ UilPaintTool } title="Projects" subtitle="All your projects, past and present"
                  actions={
                      <Button color="primary" to="/projects/add" renderAs={ Link }>
                          <Icon icon={ UilPlusCircle }/>&nbsp;New project
                      </Button>
                  }>

                { projects }
            </Page>
        </Loading>
    )
}
